import { TemperatureScales, TemperatureConverter } from "./temperature-value";

export class TemperatureDeltaFormatValueConverter {
  toView(value: number) {

    let temperatureScale = localStorage.getItem("temperature-scale");
    if (!temperatureScale) {
      temperatureScale = TemperatureScales.fahrenheit;
    }

    switch (temperatureScale) {
      case TemperatureScales.celsius:
        return `${value.toFixed(2)} °C`;
      default:
        const temperature = TemperatureConverter.toFahrenheit(value);
        return `${temperature.toFixed(2)} °F`;
    }

  }
}